import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'linked-template-list',
  templateUrl: './linked-template-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkedTemplateListComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() title = '';
  @Input() hideTitle = false;
  @Input() linkedTemplate = [];
  @Input() hideCheckbox = true;
  @Input() fromManageSecurity = false;
  @Input() isFixedImage = false;
  @Input() isFromLinkedTemplate = false;
  @Input() isRemoveEditSaveSharing = false;
  @Output() viewTemplate = new EventEmitter<any>();
  @Output() deleteTemplate = new EventEmitter<any>();
  @Output() connectTemplateFeedData = new EventEmitter<any>();
  @Output() reConnectTemplateFeedData = new EventEmitter<any>();
  @Output() linkedTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
  }>();

  selectionState: { [key: string]: boolean } = {};

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}

  viewModal(file, event?: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.viewTemplate.emit({ file: file, event: event });
  }
  editFeedData(item) {
    this.connectTemplateFeedData.emit(item);
  }
  reconnect(item) {
    this.reConnectTemplateFeedData.emit(item);
  }
  deleteForm(item) {
    this.deleteTemplate.emit(item);
  }

  onLinkedTemplateSelectionChange(template: any, index: number, isChecked: boolean) {
    const key = `linked_template_${index}`;
    this.selectionState[key] = isChecked;
    this.linkedTemplateSelectionChange.emit({ template, index, isChecked });
    this.cd.detectChanges();
  }

  clearSelections() {
    this.selectionState = {};
    this.cd.detectChanges();
  }

  removeTemplate(template: any) {
    this.deleteForm(template);
  }

  getProgressPercentage(template) {
    if (!template.totalCommitment) return 0;
    const percentage = (1 - template.remainingBalance / template.totalCommitment) * 100;
    return Math.max(0, Math.min(100, percentage));
  }
}
